export const VARIANT_ON = 'on';
export const VARIANT_OFF = 'off';
export const VARIANT_A = 'a';
export const VARIANT_B = 'b';
export const VARIANT_MYACCOUNT = 'MyAccount';
export const VARIANT_LOGINSIGNUP = 'LoginSignup';


// This experiment is used exclusively by nginx to determine whether to send the client to monolith or 1Z.
// We use it as a feature flag here in PWA to log to datadog when the client received the monolith variant but somehow
// ended up here in PWA.
export const ONE_Z_SEARCH = {
    experimentId: '1ZSearchRouter',
    defaultAssignment: 'default',
    isFeatureFlag: false,
};

// This experiment is used exclusively by PWA to record profile conversion.
// Nginx and monolith shouldn't touch this experiment at all.
export const ONE_Z_SEARCH_PWA = {
    experimentId: '1ZSearchTest-PWA',
    defaultAssignment: VARIANT_ON,
    isFeatureFlag: false,
};

export const PROFILE_V4 = {
    experimentId: 'ProfileV4',
    defaultAssignment: VARIANT_OFF,
    isFeatureFlag: false,
};

/**
 * this is only a test to control staging vs production visibility;
 * the functionality is also guarded by the specialtyDirectory.enabled branding flag
 */
export const SHOW_SPECIALTY_FOOTER = {
    experimentId: 'ShowSpecialtyQuickLinksFooter',
    defaultAssignment: VARIANT_OFF,
    isFeatureFlag: true,
};

export const PROFILE_1N_COMMUNITY_LABEL_SHOWN = {
    experimentId: '1NProfileCommunityLabel',
    defaultAssignment: VARIANT_OFF,
    isFeatureFlag: true,
};

export const PROFILE_1N_EDUCATION_YEARS_SHOWN = {
    experimentId: '1NProfileEducationYears',
    defaultAssignment: VARIANT_OFF,
    isFeatureFlag: true,
};

export const PROFILE_1N_INSTITUTES_SHOWN = {
    experimentId: '1NProfileInstitutes',
    defaultAssignment: VARIANT_OFF,
    isFeatureFlag: true,
};

export const HOMEPAGE_HEADER_V2 = {
    experimentId: 'HomepageHeaderV2',
    defaultAssignment: VARIANT_OFF,
    isFeatureFlag: false,
};

export const THEMED_SEARCH = {
    experimentId: 'ThemedSearch',
    defaultAssignment: VARIANT_OFF,
    isFeatureFlag: false,
};

export const UNIVERSAL_SEARCH_HEADER_PREVIEW = {
    experimentId: 'UniversalSearchHeaderPreview',
    defaultAssignment: VARIANT_OFF,
    isFeatureFlag: true,
};

export const SIGNIN_DROPDOWN_TEXT = {
    experimentId: 'SignInDropdownText',
    defaultAssignment: VARIANT_MYACCOUNT,
    isFeatureFlag: false,
};

export const SPO_REVIEW_COUNT = {
    experimentId: 'SpoReviewCountDisplay',
    defaultAssignment: VARIANT_OFF,
    isFeatureFlag: false,
};
